import React, { FC } from 'react';
import { Avatar, Flag } from '@whitesharx/starfall-frontend-ui-kit';

import { flagPositionStyles, avatarContainerStyles, containerStyles, nameStyles } from './styles.css';

export type Player = {
  avatarSrc?: string;
  setName?: string;
  country?: string;
  name?: string;
};

type PlayerGeneralInfoProps = Player & {
  isDesktop: boolean;
  isWin: boolean;
  avatarSize?: 'default' | 'small';
};

const AVATAR_SIZES = {
  default: 85,
  small: 60,
};

const PlayerGeneralInfo: FC<PlayerGeneralInfoProps> = ({
  avatarSrc,
  avatarSize,
  setName,
  country,
  name,
  isWin,
  isDesktop,
}) => {
  const size = isDesktop ? 'default' : 'small';
  return (
    <div className={containerStyles}>
      <div className={avatarContainerStyles}>
        <Avatar src={avatarSrc} size={AVATAR_SIZES[avatarSize || size]} frame={isWin ? 'win' : setName} />
        {country && (
          <div className={flagPositionStyles}>
            <Flag country={country} size={18} />
          </div>
        )}
      </div>
      <div className={nameStyles}>{name}</div>
    </div>
  );
};

export default PlayerGeneralInfo;
